import type { ConsolaOptions } from 'consola'
import { useStorage } from '@vueuse/core'
import { createConsola } from 'consola'
import defu from 'defu'

/**
 * Creates a consola instance with a tag and optional options
 * @param tag - The tag to use for the logger
 * @param options - Optional options to pass to the logger
 * @returns A consola instance
 */
export function useDevLogger(tag: string, options?: Partial<ConsolaOptions>) {
  const storage = useStorage('forgd:debug-logs', false)

  /**
   * We set the log level to verbose in dev and silent in production by default
   * Run `localStorage.setItem('forgd:debug-logs', true)` in a browser console to force debug logging
   */
  const defaultOptions: Partial<ConsolaOptions> = {
    level: import.meta.dev || storage.value ? 999 : -999,
  }

  const logger = createConsola(defu(defaultOptions, options, { defaults: { tag } }))

  return logger
}
